import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import * as d3 from 'd3';
import { ConfirmationDialogComponent } from 'src/app/components/shared/confirmation-dialog/confirmation-dialog.component';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { SocketService } from 'src/app/services/socket/socket.service';
import { environment } from 'src/environments/environment';
import { ConfirmdialogComponent } from '../confirmdialog/confirmdialog.component';
import { MessageService } from 'src/app/services/message/message.service';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-create-graph',
  templateUrl: './create-graph.component.html',
  styleUrls: ['./create-graph.component.scss']
})
export class CreateGraphComponent implements OnInit, AfterViewInit {

  @Input() subjects: any[] = [];
  @Input() projectUsers: any[] = [];
  userID = JSON.parse(localStorage.getItem('currentUser'))['id'];
  userAdmin = false;
  @Input() allProjectUsers: any[] = [];
  @Input() projectLib: string = "Project";
  @Input() levelShowed: number = 0;
  @Output() create = new EventEmitter<void>();
  @Output() emitProjectUpdate = new EventEmitter<void>();
  @Input() projectview = false;
  @Input() isAdmin = false;
  @Input() creator = null;
  @Input() idProjet = null;
  @Input() contacts: any[] = [];
  otherContacts: any[] = [];
  projectLibelle = "Project";
  projectUsersCopy: any[] = [];
  subjectsPerPage = 8;
  currentPage = 0;
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  ongletId = this.messageService.getOngletId();
  selectedUsers = [];
  selectedEmails = [];
  addingMembers = [];
  userStatus = null;

  mailInputShow = 0;
  contactemail = '';
  inputemail = '';
  emailPattern: string = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  externalEmails: string[] = [];
  addcontactshow = 0;
  selectedRole: string = 'collaborator';
  @ViewChild('emailInput0', {static: true}) emailInput0: ElementRef;
  emailFormControl = new FormControl('', [
      Validators.required,
      Validators.email,
  ]);

  /*positions = [
    { top: '10%', left: '50%' },     // top
    { top: '10%', left: '90%' }, // top-right
    { top: '50%', left: '90%' },   // right
    { top: '90%', left: '90%' }, // bottom-right
    { top: '90%', left: '50%' },    // bottom
    { top: '90%', left: '10%' },      // bottom-left
    { top: '50%', left: '10%' },                // left
    { top: '10%', left: '10%' },                  // top-left
  ];*/
  positions = [
    { top: '0%', left: '37%' },     // top
    { top: '0%', left: '74%' }, // top-right
    { top: '40%', left: '74%' },   // right
    { top: '80%', left: '74%' }, // bottom-right
    { top: '80%', left: '37%' },    // bottom
    { top: '80%', left: '0%' },      // bottom-left
    { top: '40%', left: '0%' },                // left
    { top: '0%', left: '0%' },                  // top-left
  ];
  @ViewChild('parentiv', {static: false}) parentiv!: ElementRef<any>;
  //centerX = 165; // centre du svg (ex: 300px wrapper)
  //centerY = 165;
  centerX = 155; // centre du svg (ex: 300px wrapper)
  centerY = 133.5;
  divwidth = 330;
  divheight = 330;
  tagRenameShow = false;
  projRenameShow = false;
  selectedTag : any;
  mode = 1;
  activeConfirmIndex: number | null = null;
  searchContact: any;
  searchTagContact: any;
  indexUpd = 0;
  currentUserInfo: any;
  editingIndex: number | null = null;
  editedLabel = '';
  oldLabel = '';
  editingProject: boolean = false;
  editedLabelProject = '';
  oldLabelProject = '';
  @Output() projectRenamed = new EventEmitter<string>();

  constructor(private authService: AuthService, private socketService: SocketService, private messageService: MessageService, public dialog: MatDialog, private cdr: ChangeDetectorRef,){
    var currentUserData = JSON.parse(localStorage.getItem('currentUser'));
    this.currentUserInfo = currentUserData.givenName + currentUserData.familyName;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.recalculateDimensions();
  }

  recalculateDimensions() {
    if (!this.parentiv) return;
    const width = this.parentiv.nativeElement.offsetWidth;
    const height = this.parentiv.nativeElement.offsetHeight;
    this.divwidth = width;
    this.divheight = height;
    this.centerX = width / 2;
    this.centerY = height / 2;
  }

  editSubject(tag, index: number) {
    this.editingIndex = index;
    this.oldLabel = tag.libelle;
    this.editedLabel = this.oldLabel;
  }

  confirmEdit(i: number){
    this.authService.changeSubjectName(this.editedLabel, this.paginatedSubjects[i].id).subscribe((res)=>{
      //this.projectTags[this.indexUpd].libelle = this.updateSubject;
      this.subjects[i].libelle = this.editedLabel;
      this.authService.subjectListUpd.emit(res);
      this.authService.obSubRename.next(res);
      this.editingIndex = null;
    },
      (error) => {
        err=>console.log(err)
      }
    );
    return;
  }

  cancelEdit() {
    this.editingIndex = null;
    this.editingProject = false;
  }

  editProject() {
    this.editingProject = true;
    this.oldLabelProject = this.projectLibelle;
    this.editedLabelProject = this.oldLabelProject;
  }

  confirmEditProject(){
    this.authService.changeProjetName(this.editedLabelProject, this.idProjet).subscribe(
      res => {
        this.projRenameShow = false;
        this.editingIndex = null;
        this.editingProject = false;
        this.projectLibelle = this.editedLabelProject;
        this.projectRenamed.emit(this.editedLabelProject);
        this.socketService.sendInstant({
              id: "",
              action: this.idProjet, // ID du projet
              type: "RENAMEPROJECT",
              author: this.currentUser, // peu importe 
              recipient: "", // peu importe 
              text: "",
              copy: "",
              private: false,
              res: res["libelle"], // le nouveau nom
              date: ""
        });
        //this.authService.obRefreshProjet.next();
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );
  }

  cancelEditProject() {
    this.editingIndex = null;
    this.editingProject = false;
  }

  ngAfterViewInit(): void {
    // Assure-toi que la div est bien rendue avant d'accéder à sa largeur
    const width = this.parentiv.nativeElement.offsetWidth;
    const height = this.parentiv.nativeElement.offsetHeight;
    this.divwidth = width;
    this.divheight = height;
    this.centerX = width / 2;
    this.centerY = height / 2;
    this.recalculateDimensions();
  }

  ngOnChanges() {
    /*if (this.contacts && this.projectUsersCopy) {
      this.filterOtherContacts();
    }*/
  }

  private filterOtherContacts() {
    const projectUserIds = this.projectUsersCopy.map(u => u.id);

    this.otherContacts = this.contacts.filter(
      contact => !projectUserIds.includes(contact.id)
    );
  }

  getFormattedName(member: { givenName: string; familyName: string }): string {
    if(member.familyName){
      const firstInitial = member.familyName.charAt(0).toUpperCase();
      return `${member.givenName} .${firstInitial}`;
    } else return member.givenName;
    
  }

  isUserInTag(contact: any): boolean {
    if (!this.selectedTag || !this.selectedTag.userTag) return false;
    return this.selectedTag.userTag.findIndex(member => member.user.id === contact.id) !== -1;
  }

  addMemberToProject() {
    this.projectUsersCopy = [];
    
    var userData = JSON.parse(localStorage.getItem('currentUser'));
    this.projectUsersCopy = this.allProjectUsers.map(item => item.user);
    this.projectUsersCopy.unshift(userData);
    this.mode = 4;
    this.editingIndex = null;
    this.editingProject = false;
    this.addcontactshow = 0;
  }

  showEmailInvited(){
    this.addcontactshow = 1;
    if(this.emailInput0) this.emailInput0.nativeElement.value = "";
    
  }

  fctAddcontactByMail(){

      // Process checkout data here
      //console.log('Your order has been submitted', customerData);
       // stop here if form is invalid
      if (this.emailFormControl.status == 'INVALID') {
        return;
      }

      var result = this.emailFormControl.value;

      this.authService.addUserProjectWithRole("/api/projects/"+this.idProjet, result, this.selectedRole, true).subscribe(res => {
         //console.log('retour ajout membre mail => '+JSON.stringify(res));
        this.searchContact = "";
        alert('Invitation envoyé'); 
        this.addcontactshow = 0;
        
        if(res['user'] && res['user']['id']){
          var newUser = res;
          this.userStatus[res['user']['id']] = res['status'];
          this.projectUsers.push(newUser);
          this.messageService.needRefreshFiltre();
          var usersinvited = [];
          usersinvited.push(res['user']['id']);
          var contact = this.contacts.find(i => i.id === res['user']['id']);
          if (!contact){
                this.contacts.push(res['user']);
          }
          this.socketService.sendInstant({
            id: "0",
            action: "0",
            type: "INVITATIONPROJ",
            author: this.userID,
            recipient: "",
            text: "",
            copy: usersinvited,
            private: false,
            res: "",
            project_lib: this.projectLib,
            date: result.dateCreated
          });
         } else {
          this.projectUsers.push(res);
          this.messageService.needRefreshFiltre();
         }

         //this.emailFormControl.value = null;
         this.emailInput0.nativeElement.value = "";
      },
      (error) => {
        if (error.status === 402) {
          const errorDescription = JSON.parse(error.error['hydra:description']);
          //this.openPackComponentDialog(2, errorDescription.subscriptionPack);
        } else if (error.status === 429) {
          //this.openPackComponentDialog(3);
        } else if(error.error && error.error.violations){
          alert(error.error.violations[0].message);
        } else if(error.error && error.error['hydra:description']){
          alert(error.error['hydra:description']);
        } else
        {
          alert(error.statusText);
        }

      });

   }

  fctCheckMemberProject(){}

  getbackGroundColor(){
    return "#57b031";
  }

  fctAdMember(userInfo){
    this.authService.addUserProject("/api/projects/"+this.idProjet, userInfo.id, null).subscribe(res => {
       if(res){
        var newUser = res;
        this.userStatus[res['user']['id']] = res['status'];
        this.projectUsers.push(newUser);
        this.allProjectUsers.push(newUser);
        this.projectUsersCopy.push(res['user']);
        this.searchContact = "";
        this.searchTagContact = "";
        var currentusername = JSON.parse(localStorage.getItem('currentUser'))['givenName'] +" "+ JSON.parse(localStorage.getItem('currentUser'))['familyName'];
        //this.authService.obRefreshProjet.next();
        this.socketService.sendInstant({
          id: "0",
          action: "0",
          type: "INVITATION",
          author: this.currentUser.id,
          recipient: currentusername,
          text: res['user']['id'],
          copy: "",
          private: false,
          res: res,
          project_lib: this.projectLib,
          date: res['dateCreated']
        });
       }
    },
    (error) => {
      if(error.error && error.error.violations){
        alert(error.error.violations[0].message);
      }
      else
      {
        alert(error.statusText);
      }

    });

  }

  addMemberToTag() {
    this.mode = 5;
  }

  fctCheckMemberTag(userInfo) {
      if (this.selectedTag.users && !this.selectedTag.users.some(user => user.id === userInfo.id)) {
        this.fctAdMemberTag(userInfo);
      } else {
        this.fctRemoveUserTag(userInfo);
      }
  }

  fctAdMemberTag(userInfo) {
      if (!this.selectedTag.users) {
        this.selectedTag.users = [];
      }
      this.selectedTag.users.push(userInfo);
      this.searchContact = "";
      this.searchTagContact = "";
  }

  fctRemoveUserTag(userInfo) {
      const index = this.selectedUsers.indexOf(userInfo.id);
      if (index > -1) {
        this.addingMembers.splice(index, 1);
        this.selectedUsers.splice(index, 1); // déjà sélectionné → on retire
      }
  }

  updCheckUserTag(contact){
    console.log("contaaaact : "+JSON.stringify(contact))
      const index = this.selectedUsers.indexOf(contact.id);
      if (index > -1) {
        this.addingMembers.splice(index, 1);
        this.selectedUsers.splice(index, 1); // déjà sélectionné → on retire
      } else {
        this.addingMembers.push(contact);
        this.selectedUsers.push(contact.id); // pas encore sélectionné → on ajoute
      }
  }

  openInvitations(){
    this.mailInputShow = 1;
    this.inputemail = '';
    this.contactemail = '';
  }

  isEmailValid(email: string): boolean {
      const regex = new RegExp(this.emailPattern);
      return regex.test(email);
  }

  hideMailInput(){
    this.mailInputShow = 0;
    this.inputemail = '';
    this.contactemail = '';
  }

  addExternalEmail(emailsent = null) {
    if (!this.inputemail && !emailsent) return;
    var email = emailsent;
    if(!emailsent) email = this.inputemail.trim().toLowerCase();
    if (email && !this.externalEmails.includes(email)) {
      this.externalEmails.push(email);
    }
    this.inputemail = '';
  }

  removeExternalEmail(index: number) {
    this.externalEmails.splice(index, 1);
  }

  confirmUpdate(){
    const data = {
      libelle: this.selectedTag.libelle,
      users: this.selectedUsers,
      externalEmails: this.externalEmails
    };
    this.authService.updateTagDetails(this.selectedTag.id, data).then((res)=>{
      //this.projectTags[this.indexUpd].libelle = this.updateSubject;
      this.subjects[this.indexUpd] = res;
      this.authService.subjectListUpd.emit(res);
      this.authService.obSubRename.next(res);
      this.tagRenameShow = false;
      this.reloadUsers();
      this.mode = 2;
      this.selectedTag = res;
      //this.backToList();
      //this.dialogRef.close();
    }).catch(err=>console.log(err))
    return;
  }

  reloadUsers(){
    this.authService.getOneProject(this.idProjet)
      .subscribe(res => {
        var tmpArrayUser = res['userProject'];
        this.projectUsers = [];
        this.projectUsersCopy=[];
        var users = tmpArrayUser.filter(a => a.user != null);
        users.sort((a, b) => {
          if (a.user.fullName.toLowerCase() < b.user.fullName.toLowerCase()){
            return -1;
          }
          if (a.user.fullName.toLowerCase() > b.user.fullName.toLowerCase() ){
            return 1;
          }
          return 0;
        });
        
        this.projectUsers = users.sort((a, b) => {
          // Admins en premier
          if (a.isCreator) return -1;
          if (b.isCreator) return 1;
        
          // Co-admins ensuite
          if (a.isAdmin && !a.isCreator) return -1;
          if (b.isAdmin && !b.isCreator) return 1;
        
          // Les autres membres à la fin
          return 0;
        });
        var invited = tmpArrayUser.filter(a => a.user == null);
        invited.sort((a, b) => {
          if (a.email < b.email){
            return -1;
          }
          if (a.email > b.email ){
            return 1;
          }
          return 0;
        });
        for (var i = 0; i < invited.length; i++) {
              this.projectUsers.push(invited[i]);
        }
        for (var i = 0; i < this.projectUsers.length; i++) {
          if((this.projectUsers[i].isAdmin == true) && (this.projectUsers[i].user.id == this.userID))
          {
            this.userAdmin = true;
          }
        }
        //*************************** */
        this.projectUsersCopy= [...this.projectUsers];
        this.allProjectUsers = [...this.projectUsers];
        let userStatus = [];
        for (let index = 0; index < this.allProjectUsers.length; index++) {
              if(this.allProjectUsers[index]['user']){
                userStatus[this.allProjectUsers[index]['user']['id']] = this.allProjectUsers[index]['status'];
              }
        }
        this.userStatus = userStatus;
         
      });
  }

  confirmUpdateProject(){

    if (this.projectLibelle.trim().length == 0 ){
      return;
    }

     // Creation du projet
    this.authService.changeProjetName(this.projectLibelle, this.idProjet).subscribe(
      res => {
        this.projRenameShow = false;
        this.socketService.sendInstant({
              id: "",
              action: this.idProjet, // ID du projet
              type: "RENAMEPROJECT",
              author: this.currentUser, // peu importe 
              recipient: "", // peu importe 
              text: "",
              copy: "",
              private: false,
              res: res["libelle"], // le nouveau nom
              date: ""
        });
        //this.authService.obRefreshProjet.next();
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );

  }


  toggleDeleteConfirm(subject: any, index: number) {
    // Active ou désactive la popup pour ce bouton
    this.activeConfirmIndex = this.activeConfirmIndex === index ? null : index;
    const dialogRef = this.dialog.open(ConfirmdialogComponent, {
               data: { 
                 message: 'Voulez vous vraiment suppprimer la mission '+subject.libelle+'?',
                 title: 'Confirmation'
               },
               panelClass: 'confirmclass',
               backdropClass: 'custom-backdrop'
             });
         
             dialogRef.afterClosed().subscribe(result => {
               if (result) {
                this.confirmRemove(this.paginatedSubjects[index], index);
               } else {
                 this.cancelConfirm();
               }
    });
  }

  cancelConfirm() {
    this.activeConfirmIndex = null;
  }

  confirmRemove(tag: any, index: number) {
    this.subjects = this.subjects.filter(m => m.id !== tag.id);
    this.activeConfirmIndex = null;

    // Optionnel : message
    alert("La mission a été supprimé.");
  }

  removeTag(tag){
    if(confirm("Voulez vraiment suppprimer la mission "+tag.libelle)) {
      this.subjects = this.subjects.filter(m => m.id !== tag.id);
      alert("La mission est supprimé.")
    }
  }

  updateTag(tag, i){
    this.selectedTag = tag;
    this.tagRenameShow = false;
    this.indexUpd = i;
    this.cancelEdit();
    this.cancelEditProject();
    this.mode = 2;
    this.editingIndex = null;
    this.editingProject = false;
    this.emitProjectUpdate.emit();
    this.selectedUsers = [];
    this.addingMembers = [];
    for (let index = 0; index < tag.userTag.length; index++) {
          if(tag.userTag[index]['user'] && tag.userTag[index]['user']['id'] != this.currentUser){
            this.selectedUsers.push(tag.userTag[index]['user']['id']);
            this.addingMembers.push(tag.userTag[index]['user']);
          } else if(!tag.userTag[index]['user']){
            this.externalEmails.push(tag.userTag[index]['email']);
          }

    }
  }

  goBack(): void {
    this.editingIndex = null;
    this.editingProject = false;
    switch (this.mode) {
      case 5:
        this.mode = 2;
        break;
      case 4:
        this.mode = 3;
        break;
      case 2:
        this.mode = 1;
        break;
      case 3:
        this.mode = 1;
        break;
      default:
        // Tu peux notifier le parent si tu veux qu'on quitte complètement
        break;
    }
  }


  updateProject(){
    this.selectedTag = null;
    this.tagRenameShow = false;
    this.projRenameShow = false;
    this.mode = 3;
    this.emitProjectUpdate.emit();
  }

  renameProject(){
    this.projRenameShow = true;
  }

  renameTag(){
    this.tagRenameShow = true;
  }

  get paginatedSubjects() {
    const start = this.currentPage * this.subjectsPerPage;
    return this.subjects.slice(start, start + this.subjectsPerPage);
  }

  get canGoNext(): boolean {
    return (this.currentPage + 1) * this.subjectsPerPage < this.subjects.length;
  }

  get canGoPrevious(): boolean {
    return this.currentPage > 0;
  }

  nextPage() {
    if (this.canGoNext) {
      this.currentPage++;
    }
  }

  previousPage() {
    if (this.canGoPrevious) {
      this.currentPage--;
    }
  }

  
  getPositionPx(percent: string): number {
    //const percentValue = parseFloat(percent);
    const percentValue = (parseFloat(percent) + 13);
    //return (percentValue / 100) * 330; // wrapper width/height = 300
    return (percentValue / 100) * this.divwidth; // wrapper width/height = 300
  }

  getPositionPxTop(percent: string): number {
    //const percentValue = parseFloat(percent);
    const percentValue = (parseFloat(percent) + 10);
    //return (percentValue / 100) * 330; // wrapper width/height = 300
    return (percentValue / 100) * this.divheight; // wrapper width/height = 300
  }


  // Détermine l'emplacement du prochain bouton "+"
  getNextSlotIndex(): number {
    if (this.subjects.length === 0) return 4; // premiere mission -> mid-center
    if (this.subjects.length === 1) return 1; // deuxième mission -> top-center
    return -1; // pas d'emplacement prévu au-delà
  }

  getCurrentProject() {
      this.projectUsers = [];
      if (!this.idProjet) {
        return;
      }
  
      this.authService.getOneProject(this.idProjet)
      .subscribe(res => {
          var tmpArrayUser = res['userProject'];
          var currentuserproject = null;
          currentuserproject = tmpArrayUser.find(userProject => {
            return userProject.user && userProject.user.id === this.currentUser;
          });
          this.projectUsers = [...tmpArrayUser];
          let userStatus = [];
          for (let index = 0; index < this.projectUsers.length; index++) {
                if(this.projectUsers[index]['user']){
                  userStatus[this.projectUsers[index]['user']['id']] = this.projectUsers[index]['status'];
                }

          }
          this.userStatus = userStatus;
  
        }, (error) => {
      });
        
    } 

  ngOnInit() {
    this.mode = 1;
    var userData = JSON.parse(localStorage.getItem('currentUser'));
    this.projectLibelle = this.projectLib;
    this.getCurrentProject();
    this.projectUsersCopy= [...this.projectUsers];
    this.projectUsersCopy.unshift(userData);
    //this.filterOtherContacts();
  }

  scrollRight(container: HTMLElement) {
    container.scrollBy({ left: 100, behavior: 'smooth' });
  }

  scrollLeft(container: HTMLElement) {
    container.scrollBy({ left: -100, behavior: 'smooth' });
  }
  
  getAvatarlUrl(avatarLink){
      return environment.server_url+avatarLink;
  }

  getInitials(libelle: string): string {
    if(!libelle) return;
    const words = libelle.split(' ');
    const getFirstChar = (word: string): string => {
      return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
    };
    const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point

    return initials;
  }

  /*
  @ViewChild('graphContainer', { static: true }) graphContainer!: ElementRef;

  ngOnChanges() {
    this.drawGraph();
  }

  drawGraph() {
    const width = 400;
    const height = 400;
    const radius = 120;
    const svg = d3.select(this.graphContainer.nativeElement)
      .html('')
      .append('svg')
      .attr('width', width)
      .attr('height', height);

    const centerX = width / 2;
    const centerY = height / 2;

    // Cercle central
    svg.append('circle')
      .attr('cx', centerX)
      .attr('cy', centerY)
      .attr('r', 40)
      .attr('fill', '#4CAF50');

    // Nom du projet
    svg.append('text')
      .attr('x', centerX)
      .attr('y', centerY + 5)
      .attr('text-anchor', 'middle')
      .attr('fill', 'white')
      .style('font-size', '14px')
      .text(this.projectName);

    const angleStep = 2 * Math.PI / Math.max(this.topics.length, 1);

    this.topics.forEach((topic, index) => {
      const angle = index * angleStep;
      const x = centerX + radius * Math.cos(angle);
      const y = centerY + radius * Math.sin(angle);

      // Ligne entre le centre et la mission
      svg.append('line')
        .attr('x1', centerX)
        .attr('y1', centerY)
        .attr('x2', x)
        .attr('y2', y)
        .attr('stroke', '#888');

      // Cercle de mission
      svg.append('circle')
        .attr('cx', x)
        .attr('cy', y)
        .attr('r', 20)
        .attr('fill', '#2196F3');

      // Nom du sous-groupe
      svg.append('text')
        .attr('x', x)
        .attr('y', y + 5)
        .attr('text-anchor', 'middle')
        .attr('fill', 'white')
        .style('font-size', '12px')
        .text(topic);
    });
  }*/
 center = 150;
  radius = 100;
  diameter = this.center * 2;

  selectedMembers: string[] = [];
  selectedSubject: string | null = null;

  /*
  subjects = [
    { name: 'Naissance', members: ['Alice', 'Bob'] },
    { name: 'Mariage', members: ['Claire'] },
    { name: 'Décès', members: ['Daniel'] }
  ];

  selectedMembers: string[] = [];
  selectedSubject: string | null = null;

  getX(index: number): number {
    const angle = (2 * Math.PI / (this.subjects.length + 1)) * index;
    return this.center + this.radius * Math.cos(angle);
  }

  getY(index: number): number {
    const angle = (2 * Math.PI / (this.subjects.length + 1)) * index;
    return this.center + this.radius * Math.sin(angle);
  }

  addSubject() {
    const newName = prompt('Nom du nouvelle mission ?');
    if (newName) {
      this.subjects.push({ name: newName, members: [] });
    }
  }*/

  getX(index: number): number {
    const angle = (2 * Math.PI / (this.subjects.length + 1)) * index;
    return this.center + this.radius * Math.cos(angle);
  }

  getY(index: number): number {
    const angle = (2 * Math.PI / (this.subjects.length + 1)) * index;
    return this.center + this.radius * Math.sin(angle);
  }

  emitCreate() {
    this.create.emit(); // ← déclenche l’événement vers le parent
  }
  
  getSubject(subject){
    if(subject === "Thématique d'échange"){
      return "Thématique";
      } else return subject;
  }

  showMembers(index: number) {
    this.selectedSubject = this.subjects[index].name || this.subjects[index].title || 'Mission';
    this.selectedMembers = this.subjects[index].userTag || [];
  }

  countMembers(index: number) {
    return this.subjects[index].userTag.length || 0;
  }

  showProjectMembers(index: number) {
  }

  countProjectMembers() {
    //return this.projectUsersCopy.length;
    return this.allProjectUsers.length;
  }

  updateListUser(contact,values){
    this.authService.updateUserProject(contact, values)
    .subscribe(res => {
      for (var i = 0; i < this.projectUsers.length; i++) {
        if(res['id'] ===  this.projectUsers[i]['id'])
          this.projectUsers[i] = res;
      }
      //this.authService.obRefreshProjet.next();
    });
  }

  updateUserProject(contact, key){
      let values = null;
      switch (key) {
        case 1:
          values = {isAdmin: false};
          this.updateListUser(contact, values);
          this.socketService.sendInstant({
            id: "",
            action: this.idProjet,
            type: "DELETEADMIN",
            author: this.currentUser.id,
            recipient: this.currentUserInfo,
            text: "",
            copy: "",
            private: false,
            res: contact.user.id,
            date: ""
          });
          break;
        case 2:
          values = {isMember: false};
          this.updateListUser(contact, values);
          break;
        case 3:
          values = {isAdmin: true};
          this.updateListUser(contact, values);
          this.socketService.sendInstant({
            id: "",
            action: this.idProjet,
            type: "MARKADMIN",
            author: this.currentUser.id,
            recipient: this.currentUserInfo,
            text: "",
            copy: "",
            private: false,
            res: contact.user.id,
            date: ""
          });
          break;
        case 5:
          values = {isMember: true};
          this.updateListUser(contact, values);
          break;
        case 4:
          const fullname = contact.user ? contact.user.fullName : contact.email;
          const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '350px',
            data: "Vous êtes sur le point de retirer "+fullname+" du projet ?"
          });
          dialogRef.afterClosed().subscribe(result => {
            if(result) {
              this.authService.deleteUserProject(contact)
              .subscribe(res => {
                for (var i = 0; i < this.projectUsers.length; i++) {
                  if(contact['id'] ===  this.projectUsers[i]['id'])
                    this.projectUsers.splice(i, 1); 
                }
                delete this.userStatus[contact.user.id];
                this.cdr.detectChanges();
                for (let s = 0; s < this.subjects.length; s++) {
                  if (this.subjects[s].userTag) {
                    this.subjects[s].userTag = this.subjects[s].userTag.filter(
                      ut => !(ut.user && ut.user.id === contact.user.id)
                    );
                  }
                }
                //this.authService.obRefreshProjet.next();
              });
            }
          });
          break;
        default:
          break;
      }
    }

  generateGradientDots(x1: number, y1: number, x2: number, y2: number, spacing: number): { x: number, y: number, opacity: number }[] {
    const points = [];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const distance = Math.sqrt(dx * dx + dy * dy);
    const steps = Math.floor(distance / spacing);

    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      //const opacity = 1 - t * 0.9; // de 1 à 0.2
      const opacity = 0.1 + t * 0.8; // de 0.2 à 1
      points.push({
        x: x1 + dx * t,
        y: y1 + dy * t,
        opacity: opacity
      });
    }

    return points;
  }


}

